import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { useDispatch } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import {
  salesDeliveryItemsGetAction,
  salesInvoiceViewAction,
  salesOrderItemsGetAction,
} from "../../../redux/actions/sales-action";
import CreateEditViewSalesInv from "../../../components/sales-section/sales-invoice/create-edit-view-sales-Inv";

const AddSalesInvoice = () => {
  const { itemId, type } = useParams();
  const [searchParams] = useSearchParams();

  const itemIdArray = JSON.parse(decodeURIComponent(itemId));

  //
  const cloneID = searchParams.get("cloneID");
  const isClone = cloneID ? true : false;
  //

  const allitems = itemIdArray.map((item) => {
    const { cmr_id, ...rest } = item;
    return rest;
  });
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (isClone) {
      setLoading(true);
      dispatch(salesInvoiceViewAction(cloneID, onCloneSuccPur, onErrPur));
    } else if (type === "delivery") {
      setLoading(true);
      dispatch(salesDeliveryItemsGetAction(allitems, onSuccPur, onErrPur));
    } else if (type === "sales") {
      setLoading(true);
      dispatch(salesOrderItemsGetAction(allitems, onSuccPur, onErrPur));
    }
  }, []);
  const onCloneSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };
  const onSuccPur = (data) => {
    setOrderDetail(data?.data);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };

  const orderData = orderDetail?.orderData || {};
  const vendorDetails = orderDetail?.vendorDetails?.[0] || {};
  const prefix = searchParams.get("type") || "sodtt";
  const isNew = searchParams.has("new");
  const auto = searchParams.has("auto");

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout backBtn={true} title={`${isClone ? "Clone" : "Add"} Sales Invoice`}>
          <CreateEditViewSalesInv
            // <CreateEditViewSalesInvoice
            auto={auto}
            isClone={isClone}
            clickedplus={isNew}
            payto={
              isClone
                ? orderDetail?.orderData?.soit_pay_to_address
                : vendorDetails?.[`${prefix}_pay_to_address`]
            }
            shipto={
              isClone
                ? orderDetail?.orderData?.soit_ship_to_address
                : vendorDetails?.[`${prefix}_ship_to_address`]
            }
            pageType="invoice"
            page="add"
            standAlone={type === "invoice"}
            disabled={type === "delivery"}
            type={type}
            orderDetail={orderDetail?.itemData}
            itemData={orderDetail?.itemData?.[0]}
            vendorDetails={
              isClone
                ? [orderDetail?.orderData]
                : [
                    {
                      ...vendorDetails,
                      soit_sub_total: orderData?.sub_total,
                      soit_total_gst: orderData?.total_tax,
                      soit_total_discount: orderData?.total_discount,
                      soit_total_amount: orderData?.total_amount,
                      soit_round_off_value: orderData?.round_off_value,
                      soit_tcs_or_tds_amount: orderData?.tcs_or_tds_amount,
                      soit_tcs_or_tds_percentage_id:
                        orderData?.tcs_or_tds_percentage_id,
                      soit_tcs_or_tds_percentage:
                        orderData?.tcs_or_tds_percentage,
                      soit_tds_tcs_type: orderData?.tcs_or_tds_type,
                      soit_is_invoice_dis_percentage:
                        orderData?.is_invoice_dis_percentage ?? true,
                      soit_invoice_discount: orderData?.invoice_discount ?? 0,
                      soit_invoice_discount_percentage:
                        orderData?.invoice_discount_percentage ?? 0,
                    },
                  ]
            }
          />
        </InnerLayout>
      )}
    </>
  );
};
export default AddSalesInvoice;
